'use strict';

if (!Buffer) {
    global.Buffer = require('buffer/').Buffer;
}

module.exports = Buffer;
